"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useHideSidebar = function () {
    react_1.useEffect(function () {
        // hide sidebar
        var sidebar = document.querySelector('.sidebar');
        if (sidebar) {
            sidebar.style.visibility = 'hidden';
        }
        return function () {
            if (sidebar) {
                sidebar.style.visibility = 'visible';
            }
        };
    }, []);
};
exports.default = useHideSidebar;
